"use client";
import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "@/redux/hook";

import { addProductRecentViewToLocal } from "@/lib/api/shop/products";
import { addProductRecentView } from "@/redux/features/ShopSlice";
import {
  ProductJson,
  ProductDescriptionSetting,
  ProductAllowSale,
  Images,
} from "@/types/Product.type";
import ProductImages from "./_components/productImages/ProductImages";
import ProductInfo from "./_components/productInfo/ProductInfo";
import ProductPolicy from "./_components/productPolicy/ProductPolicy";
import ProductSticky from "./_components/productSticky/ProductSticky";
import ProductDescriptions from "../productDescriptions/ProductDescriptions";
import ProductImageSkeleton from "~components/product/skeletons/ProductImageSkeleton";
import useVariants, { VariantsFromTags } from "@/lib/hooks/useVariants";
import ProductVariantGroup from "~components/product/ProductVariantGroup";
import ProductActions from "./_components/productActions/ProductActions";
import ProductTester from "./_components/productTester/ProductTester";
import useTranslationApi from "@/lib/hooks/useTranslationApi";
import useVariantsV2 from "@/lib/hooks/useVariantsV2";
import { SheetUi } from "@/components/SheetUi";
import Button from "@/components/ui/Button";

interface ProductDetailProps {
  product: ProductJson;
  store_id: number;
  descriptions: ProductDescriptionSetting[];
  variants?: ProductJson[];
  variantFromTags?: VariantsFromTags[];
}
const translate = {
  product_not_allow_sale: "product_not_allow_sale",
};

const imgsDefault = [{ url: "" }];
export default function ProductDetail({
  product,
  store_id,
  descriptions,
  variantFromTags: variantStructSize,
  variants: variantlist,
}: ProductDetailProps) {
  const { t } = useTranslationApi(Object.values(translate));
  const dispatch = useAppDispatch();

  const productRecentViewList = useAppSelector(
    (state) => state.ShopReducer.listProductRecentView
  );
  const [open, setOpen] = useState(false)

  const {
    handleActiveVariant,
    variantActive,
    variants,
    variantFromTags,
    isLoading,
    refetch,
  } = useVariantsV2({
    product: product,
    variantFromTagsDefauilt: variantStructSize,
    variantsDefauilt: variantlist,
  });
  const [imageActive, setImageActive] = useState<number>(0);
  const [listImageActive, setListImageActive] = useState<Images[]>(imgsDefault);
  const [quantity, setQuantity] = useState(1);
  const handleSetVariant = (variant: ProductJson) => {
    handleActiveVariant(variant);
  };

  function handlerSubQuantity() {
    setQuantity((quantity) => quantity - 1);
  }

  function handlerAddQuantity() {
    setQuantity((quantity) => quantity + 1);
  }
  function handleSetQuantity(quantity: number) {
    setQuantity(quantity);
  }

  // init
  useEffect(() => {
    if (productRecentViewList.length) {
      dispatch(addProductRecentView(product));
    } else {
      addProductRecentViewToLocal(product.id);
    }
  }, [product.id]);

  useEffect(() => {
    if (variantActive.images.length) {
      setListImageActive(variantActive.images);
    } else {
      setListImageActive(imgsDefault);
    }
    setImageActive(0)

  }, [variantActive]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="grid grid-cols-12 gap-4 min-h-[calc(100vh-218px)] ">
        
        <div className="col-span-12 md:col-span-4 lg:col-span-4 relative flex-shrink-0">
          {isLoading ? (
            <ProductImageSkeleton />
          ) : (
            <ProductImages
              images={listImageActive}
              indexActive={imageActive}
              onChangeImage={(value) => {
                setImageActive(value);
              }}
            />
          )}
          {variantActive.tags.some(
            (item) => item.type === "PRODUCT TESTER"
          ) && (
              <ProductTester
                tags={variantActive.tags}
                className="absolute top-0 left-0 z-10"
              />
            )}
        </div>
        <div className="col-span-12 md:col-span-8 lg:col-span-6">
          {variantActive.allow_sale === ProductAllowSale.ALLOW_SALE ? null : (
            <h4 className=" text-red-500 font-bold text-lg mb-2">
              {/* SẢN PHẨM ĐÃ NGỪNG KINH DOANH */}
              {t(translate.product_not_allow_sale)}
            </h4>
          )}
 


          <ProductInfo
            // loading={loading}
            data={product}
            productVariantActive={variantActive}
          />
          <ProductVariantGroup
            loading={isLoading}
            variantActive={variantActive}
            variantFromTags={variantFromTags}
            handleActiveVariant={handleSetVariant}
            className="mt-4"
          />
          {/* <ProductMyPromotions /> */}
          <ProductPolicy className="mt-4" />
        </div>
        {variantActive.allow_sale === ProductAllowSale.ALLOW_SALE && (
          <ProductActions
            refetch={refetch}
            quantity={quantity}
            handleSetQuantity={handleSetQuantity}
            handlerSubQuantity={handlerSubQuantity}
            handlerAddQuantity={handlerAddQuantity}
            productVariant={variantActive}
            isLoadProductVariant={isLoading}
            handleActiveVariant={handleSetVariant}
            className="col-span-12 md:col-span-6 lg:col-span-2"
          />
        )}
        <ProductSticky
          quantity={quantity}
          productVariants={variants}
          product={product}
          productVariantActive={variantActive}
          onClickProductVariant={handleSetVariant}
          store_id={store_id}
        />
      </div>
      <ProductDescriptions
        product={product}
        sku={variantActive.sku}
        descriptions={descriptions}
        className="w-full mb-8"
      />
    </>
  );
}
